import React from 'react'; 
import GlobalStyles from './assests/styles/global';
// import ReactDOM from 'react-dom'
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
           <App />
        </Provider>
    </React.StrictMode>
)